import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { TranslateService } from '@ngx-translate/core';
import { catchError, from, switchMap, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const keycloakService = inject(KeycloakService);
    // Hacer TranslateService opcional con fallback a 'es'
    // Esto evita NullInjectorError en apps que no tienen configurado TranslateModule
    const translateService = inject(TranslateService, { optional: true });

    // Primero verificamos si el token necesita actualizarse (menor a 40 segundos)
    return from(keycloakService.updateToken(40)).pipe(
        // Manejamos cualquier error en la actualización del token
        catchError((error) => {
            console.error('Error al actualizar el token:', error);
            // Redirigimos al login como efecto secundario, propagando el error original
            keycloakService.login();
            return throwError(() => new Error('Sesión expirada. Redirigiendo al login.', { cause: error }));
        }),
        // Si la actualización es exitosa, obtenemos el token actual
        switchMap(() => keycloakService.getToken()),
        switchMap((token) => {
            // Obtener el idioma actual, con fallback a 'es' si no hay TranslateService
            const currentLang = translateService?.currentLang || 'es';
            
            const authReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`,
                    'Accept-Language': currentLang,
                },
            });
            return next(authReq);
        }),
    );
};
